export default {
  maintainAspectRatio: false,
  legend: {
    position: 'right',
    labels: {
      fontFamily: 'monospace',
      fontSize: 16
    }
  },
  scales: {
    xAxes: [{
      ticks: {
        fontSize: 16,
        minRotation: 45
      }
    }],
    yAxes: [{
      ticks: {
        fontSize: 16,
        callback: function (value, index, values) {
          return '€' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        }
      }
    }]
  },
  tooltips: {
    callbacks: {
      label: function (tooltipItem) {
        var label = tooltipItem.yLabel
        return '€' + label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/reports/ChartOptions.js